import $ from 'jquery'
import { formatNumberCompact } from './number-display'
import { parseBackendTimestamp } from './backend-timestamp'
import { cca_config } from '../plugins/cca-config'
import Vue from 'vue';
import VueHtml2pdf from 'vue-html2pdf'
import excel from 'vue-excel-export'
import EnteteBonEtFacture from '@/components/en-tete-bon-facture';

 
Vue.use(excel)
// import moment from 'moment';
Vue.use(VueHtml2pdf)

export const utilMixins = {
    components: {
        EnteteBonEtFacture
    },

    data() {
        return {
            assets_path: cca_config.C_URL+cca_config.C_URL_CAISSE_ASSET,
            clinique_assets_path: cca_config.C_URL+cca_config.C_URL_ASSET,

            base_url_clinique: cca_config.C_CLINIQUE_FE_URL,
            base_url_caisse: cca_config.C_CAISSE_FE_URL,
            base_url_stock: cca_config.C_STOCK_FE_URL,
            base_url_rh: cca_config.C_RH_FE_URL,

            foot_1: "",
            foot_2: "",
            foot_3: '',
            status_is_loading: true,
            token: "gg",

            list_months: [
                { id: '', lib: "Choisir" }, 
                { id: 1, lib: "Janvier" }, { id: 2, lib: "Février" },
                { id: 3, lib: "Mars" }, { id: 4, lib: "Avril" },
                { id: 5, lib: "Mai" }, { id: 6, lib: "Juin" },
                { id: 7, lib: "Juillet" }, { id: 8, lib: "Août" },
                { id: 9, lib: "Septembre" }, { id: 10, lib: "Octobre" },
                { id: 11, lib: "Novembre" }, { id: 12, lib: "Décembre" },
            ],
            current_date: new Date(),
            is_printing: false,

            info_currency: {},
            principal_currency: '',
            secondary_currency: '',
            currency_lang: '',
            has_two_currencies: '',
            currency_info: {
                principal_currency: 'F.CFA',
                secondary_currency: '',
                rate: ''
            },

            nom_clinique: '',
            logo_clinique: '',
            has_info: false,
            info_clinique: {
                'logo': '', 'type_centre': '', 'nom': '',
                'pays': '', 'fuseau_horaire': '', 'ville': '', 'adresse': '', 'specialites': '',
                'code_autorisation': '', 'entete': ''
            },
            default_country_code: '', 
            ville: '',
            is_sfe: '',
            is_modele_analyse: '',

            // default_country_code: cca_config.COUNTRY_CODE,
            // ville: cca_config.VILLE,
            // is_sfe: cca_config.IS_SFE,
            // can_set_pac: cca_config.CAN_SET_PAC,
            // currency_lang: cca_config.CURRENCY_LANG,
            // has_two_currencies: cca_config.HAS_TWO_CURRENCIES,
            // principal_currency: cca_config.PRINCIPAL_CURRENCY,
            // secondary_currency: cca_config.SECONDARY_CURRENCY,
            // currency_info: {
            //     principal_currency: 'F.CFA',
            //     secondary_currency: '',
            //     rate: ''
            // },

            PUSHER_APP_KEY: cca_config.PUSHER_APP_KEY,
            PUSHER_APP_CLUSTER: cca_config.PUSHER_APP_CLUSTER
        };
    },


    created() {
        this.info_clinique = this.$store.getters["config_info_clinique"]
        this.info_currency = this.$store.getters["info_currency"] || {}
        
        document.title = cca_config.VUE_APP_NAME
    },

    computed: {
        can_set_pac() {
            const value = (this.$store.getters.config_info_clinique || {}).can_set_pac
            return value === true || value === 1 || ['1', 'true', 'on', 'yes'].includes(String(value).trim().toLowerCase())
        },
        /**
         * Liste of months of the year [ From january to current month ]
         * @returns 
         */
        monthOfYear() {
            let index;
            let m = []
            for (index = 0; index <= this.current_date.getMonth() + 1; index++) {
                m[index] = this.list_months[index];
            }
            return m;
        },
    },

    mounted() { 
        this.checkInfoClinique()
    },

    methods: {
        formatNumberCompact,
        checkInfoClinique() {
            this.has_info = this.info_clinique.has_info
            this.nom_clinique = this.info_clinique.nom
            this.logo_clinique = this.info_clinique.logo
            this.ville = this.info_clinique.ville
            this.default_country_code = this.info_clinique.code_pays
            this.is_sfe = this.info_clinique.is_sfe
            this.is_modele_analyse = this.info_clinique.is_modele_analyse

            // Currency info
            this.principal_currency = this.info_currency.label_principal_currency
            this.secondary_currency = this.info_currency.label_secondary_currency
            this.currency_lang = this.info_currency.currency_lang
            this.has_two_currencies = this.info_currency.has_two_currencies
            this.currency_info = {
                principal_currency: this.info_currency.principal_currency,
                secondary_currency: this.info_currency.secondary_currency,
                rate: this.info_currency.rate
            }
        },

        getClinicTimezone() {
            const info = this.$store && this.$store.getters && this.$store.getters['config_info_clinique']
            return (info && info.fuseau_horaire)
                || (this.info_clinique && this.info_clinique.fuseau_horaire)
                || Intl.DateTimeFormat().resolvedOptions().timeZone
        },

        getDatePartsInClinicTimezone(date) {
            if (!(date instanceof Date) || isNaN(date.getTime())) {
                return null
            }

            const parts = {}
            new Intl.DateTimeFormat('fr-FR', {
                timeZone: this.getClinicTimezone(),
                year: 'numeric', month: '2-digit', day: '2-digit',
                hour: '2-digit', minute: '2-digit', hour12: false
            }).formatToParts(date).forEach(({ type, value }) => {
                parts[type] = value
            })
            if (parts.hour === '24') parts.hour = '00'
            return parts
        },

        formatDateToDateHour(given_date) {
            if (given_date === null || given_date === undefined || given_date === '') return ''
            let date = parseBackendTimestamp(given_date);
            const parts = this.getDatePartsInClinicTimezone(date);
            if (!parts) return ''

            let only_date = parts.day + "/" + parts.month + "/" + parts.year;
            let only_hour = parts.hour + "h" + parts.minute;

            return only_date + " à " + only_hour;
        },

        formatDateToDmY(given_date) {
            if (given_date === null || given_date === undefined || given_date === '') return ''
            let date = parseBackendTimestamp(given_date);
            const parts = this.getDatePartsInClinicTimezone(date);
            if (!parts) return ''

            return parts.day + "/" + parts.month + "/" + parts.year;
        },

        getCurrentDate() {
            const parts = this.getDatePartsInClinicTimezone(new Date())
            return parts.day + '/' + parts.month + '/' + parts.year
        },

        setDates() {
            const now = new Date();
            const yesterday = new Date(now.getTime() - 24 * 60 * 60 * 1000);

            const today_parts = this.getDatePartsInClinicTimezone(now);
            const yesterday_parts = this.getDatePartsInClinicTimezone(yesterday);

            const today_date = `${today_parts.year}-${Number(today_parts.month)}-${Number(today_parts.day)}`;
            const yesterday_date = `${yesterday_parts.year}-${Number(yesterday_parts.month)}-${Number(yesterday_parts.day)}`;
            return { today_date, yesterday_date };
        },

        /**
         * Format input to only digit
         * @param {*} selector
         */
        async onlyDigits(selector) {
            $("#" + selector).val(
                $("#" + selector)
                    .val()
                    .replace(/[^0-9]+/g, "")
            );
        },

        formatCurrency(num) {
            if (num == null || num == undefined || num == '') {
                return 0
            }
            return new Number(num).toLocaleString(this.currency_lang);
        },

        successToast: function (message) {
            this.$toasted.show(message, {
                duration: 3000,
                action: [
                    {
                        text: "X",
                        onClick: (e, toastObject) => {
                            toastObject.goAway(0);
                        },
                    },
                ],
                theme: "toasted-primary",
                type: "success",
                position: "top-center",
            });
        },

        warningToast: function (message) {
            this.$toasted.show(message, {
                duration: 4000,
                action: [
                    {
                        text: "X",
                        onClick: (e, toastObject) => {
                            toastObject.goAway(0);
                        },
                    },
                ],
                theme: "toasted-warning",
                type: "warning",
                position: "top-center",
            });
        },

        dangerToast: function (message) {
            this.$toasted.show(message, {
                duration: 4000,
                action: [
                    {
                        text: "X",
                        onClick: (e, toastObject) => {
                            toastObject.goAway(0);
                        },
                    },
                ],
                theme: "toasted-danger",
                type: "danger",
                position: "top-center",
            });
        },

        goTo(url) {
            this.$router.push({ path: url });
        },

        printPDF(ref) {
            this.is_printing = true
            if (ref === undefined) {
                this.$refs.html2Pdf.generatePdf()
            } else {
                this.$refs.ref_html2Pdf.generatePdf()
            }
        },

        async beforeDownload({ html2pdf, options, pdfContent }, format, water_mark_text='') {
            const newOptions = {
                ...options,
                pagebreak: {
                    mode: ['avoid-all']
                },
            }

            
            await html2pdf().set(newOptions).from(pdfContent).set(
                {
                    margin: [0.2, 0, 1, 0],
                    image: { type: 'jpeg', quality: 0.98 }
                }
            ).toPdf().get('pdf').then((pdf) => {
                const totalPages = pdf.internal.getNumberOfPages()
                this.getFooter()

                const page_size = pdf.internal.pageSize.getWidth()
                const page_height = pdf.internal.pageSize.getHeight()

                for (let i = 1; i <= totalPages; i++) {
                    pdf.setPage(i)

                    // pdf.setFont('Arial', 'B', 8)
                    if (format == 'a4') {
                        pdf.setFontSize(10)
                        pdf.text(this.foot_1, (page_size / 2), (page_height - 0.5), {align: 'center'})
                        pdf.text(this.foot_2, (page_size / 2), (page_height - 0.3), {align: 'center'})
                    } else if (format == 'a5') {
                        pdf.setFontSize(8)
                        pdf.text(this.foot_1, (page_size / 2), (page_height - 0.7), {align: 'center'})
                        pdf.text(this.foot_2, (page_size / 2), (page_height - 0.5), {align: 'center'})
                        pdf.text(this.foot_3, (page_size / 2), (page_height - 0.3), {align: 'center'})
                    }

                    pdf.setFontSize(10)
                    pdf.text(water_mark_text, (page_size - 0.4), (page_height - 0.1), {align: 'right'})

                } 
            }).save().then(() => {
                this.is_printing = false
            })
        },

        

        getFooter() {
            // EPHATA
            this.foot_1 = cca_config.FOOT_1
            this.foot_2 = cca_config.FOOT_2
        },

        hasDownloaded() { },

        onProgress() { },

        startPagination() { },

        hasPaginated() { },

        /**
         * Validate a string not to be empty
         * @param {*} value 
         */
        validateStringNotEmpty(value) {
            if (typeof value  === 'string') {
                if (value.trim().length === 0) {
                    return true
                }
            }

            if (value == null) {
                return true
            }
            return false
        },

        transformToNumber(value) {
            return +value;
        },

        cleanNumber(value) {
            if (this.validateStringNotEmpty(value)) {
                return ''
            }
            value = this.transformToNumber(value)
            if (!this.validateNumber(value)) {
                return ''
            }
            return value
        },

        validateNumber(number) {
            if (isNaN(number) || typeof number !== 'number') {
              return false
            }
            return true
        },

        isObjectEmpty(obj) {
            return Object.keys(obj).length === 0;
        },

        /**
         * Check that the insurance contract is valid
         * @returns 
         */
        InsuranceIsValid(assurance_est_expire) {
            if (assurance_est_expire == 1) {
                return false
            }
            return true
        },

        /**
         * Check if number is greater than 0
         * @param {*} amount 
         */
        checkIfNumberGreaterThanZero(amount) {
            amount = +amount
            if (amount == 0) {
                return false
            }
            return true
        },

        /**
         * Check if the cash register is opened.
         * If close redirect to dashboard. 
         */
        checkRegisterCashStatus(compte_id) {
            this.status_is_loading = true
            const data = {
                compte_id: compte_id
            }

            this.$store.dispatch('getEtatOuvertureCaisse', data).then(() => {
                if (this.etat_ouverture_caisse.close_status == 1 || this.etat_ouverture_caisse.length == 0) {         // CLOSED
                    this.$router.push({ path: '/clinicaa/comptabilite/caisse' })
                }
                this.status_is_loading = false
            })
        },

        toggleCollapse(selector) {
            const el = document.getElementById(selector)
            const hd = document.querySelectorAll(".section-box")
            
            if (hd != null) {
                for (let i = 0; i < hd.length; ++i) {
                    hd[i].classList.remove('show');
                }
            }
            
            el.classList.add('show')
        },

        /**
         * Libellé d'une prestation sans le suffixe « (urgence) » ajouté par le serveur : l'écran affiche à la place
         * « - urgence » en petit et en rouge (le libellé enregistré, imprimé sur les tickets, garde le suffixe)
         */
        libelleSansUrgence(libelle) {
            return String(libelle || '').replace(/\s*\(urgence\)\s*$/i, '')
        },

        capitalizeFirstLetter(c) {
            let s = c.charAt(0)
            s = s.toUpperCase()+c.slice(1)
            return s
        },

        capitalizeStr(str) {
            str = str.toUpperCase()
            return str
        },

        cutString(value, len) {
            let str_value = value.substr(0, len)
            return str_value
        },

        /**
         * Normalise une valeur destinée à un contrat API historique.
         *
         * Les API Caisse enregistrent encore H/F. Cette méthode ne sert donc
         * jamais à l'affichage : elle évite que la présentation M/F soit
         * réinjectée accidentellement dans un bon ou une proforma.
         */
        formatSexeMetier(value, fallback = '') {
            const rawValue = value && typeof value === 'object'
                ? (value.specificatif || value.description || value.libelle || '')
                : value
            const raw = rawValue == null ? '' : String(rawValue).trim()
            const normalized = raw
                .toLocaleLowerCase('fr-FR')
                .normalize('NFD')
                .replace(/[\u0300-\u036f]/g, '')

            if (['h', 'm', 'homme', 'masculin', 'masculine', 'male'].includes(normalized)) return 'H'
            if (['f', 'femme', 'feminin', 'feminine', 'female'].includes(normalized)) return 'F'

            return fallback
        },

        /**
         * Rend l'abréviation du sexe uniforme dans l'interface et les
         * impressions, sans modifier la valeur métier conservée en base.
         */
        formatSexeCourt(value, fallback = '—') {
            const rawValue = value && typeof value === 'object'
                ? (value.specificatif || value.description || value.libelle || '')
                : value
            const raw = rawValue == null ? '' : String(rawValue).trim()
            const normalized = raw
                .toLocaleLowerCase('fr-FR')
                .normalize('NFD')
                .replace(/[\u0300-\u036f]/g, '')

            if (['h', 'm', 'homme', 'masculin', 'masculine', 'male'].includes(normalized)) return 'M'
            if (['f', 'femme', 'feminin', 'feminine', 'female'].includes(normalized)) return 'F'

            return raw || fallback
        },

        shortenString(value) {
            let shorten_string = value
            // let len = value.length

            // if (len > s_len) {
            //     shorten_string = value.substr(0, s_len)+'...'
            // }

            return shorten_string
        },

        setLibellePrestation(type_prestation) {
            let libelle = '';

            switch (type_prestation) {
                case 'acte':
                    libelle = 'Acte.s';
                    break;
                case 'admission':
                    libelle = 'Admission.s';
                    break;
                case 'analyse':
                    libelle = 'Analyse.s';
                    break;
                case 'apport_social':
                    libelle = 'Apport social';
                    break;
                case 'bon_consultation':
                    libelle = 'Bon de consultation';
                    break;
                case 'consultation':
                    libelle = 'Consultations';
                    break;
                case 'chambre':
                    libelle = 'Chambre.s';
                    break;
                case 'consommable':
                    libelle = 'Consommable.s';
                    break;
                case 'consommable_bon':
                    libelle = 'Consommables de bon de consultation';
                    break;
                case 'depense':
                    libelle = 'Dépense.s';
                    break;
                case 'examen':
                    libelle = 'Examen.s';
                    break;
                case 'medicament':
                    libelle = 'Médicament.s';
                    break;
                case 'observation':
                    libelle = 'Observation.s';
                    break;
                case 'bilan_sante':
                    libelle = 'Bilan de santé';
                    break;
                case 'chirurgie':
                    libelle = 'Chirurgies';
                    break;
                case 'reglement_dette':
                    libelle = 'Règlement de dettes';
                    break;
            }
            return libelle;
        },


        setLibelleGroupTaxation(key) {
            let libelle = ''
            switch(key) {
                case 'a':
                    libelle = 'A- EXONERE'
                    break;
                case 'b':
                    libelle = 'B- TAXABLE 18%'
                    break;
                case 'c': 
                    libelle = 'C- EXPORTATION'
                    break;
                case 'd': 
                    libelle = 'D- TVA REGIME D\'EXCEPTION 18%'
                    break;
                case 'e':
                    libelle = 'E- REGIME TPS'
                    break;
                case 'f': 
                    libelle = 'F- RESERVE'
                    break;
                case 'aibA':
                    libelle = 'AIB (1%)'
                    break;
                case 'aibB':
                    libelle = 'AIB (5%)'
                    break;
                case 'n_a':
                    libelle = 'AIB (N/A)'
                    break;
            }
            return libelle
        },

        /**
         * Set UID for an array of prestation
         * @param {Array} prestations  
         */
        setPrestationUID(prestations) {
            prestations.forEach((analyse, index) => {
                const tm = new Date()
                let dtime = ''+tm.getTime()
                dtime = this.shuffle(dtime)
                let tmp_uid = analyse.nom
                tmp_uid = tmp_uid.replace(" ", "_")
                tmp_uid = tmp_uid.replace("/", "_")
                tmp_uid = tmp_uid.toLowerCase()+''+dtime
                tmp_uid = tmp_uid.replace("  ", "_")
                tmp_uid = tmp_uid.replace(" ", "_")
                prestations[index]['uid'] = tmp_uid
            });
            return prestations
        },

        /**
         * Set UID for a single prestation
         * @param {*} libelle 
         */
        setSinglePrestationUID(libelle) {
            const tm = new Date()
            let dtime = ''+tm.getTime()
            dtime = this.shuffle(dtime)
            let tmp_uid = libelle
            tmp_uid = tmp_uid.replace(" ", "_")
            tmp_uid = tmp_uid.replace("/", "_")
            tmp_uid = tmp_uid.toLowerCase()+''+dtime
            tmp_uid = tmp_uid.replace("  ", "_")
            tmp_uid = tmp_uid.replace(" ", "_")
            
            return tmp_uid
        },

        /**
         * Shuffle string
         * @param {*} s 
         * @returns 
         */
        shuffle(s) {
            var arr = s.split('');           // Convert String to array
            
            arr.sort(function() {
              return 0.5 - Math.random();
            });  
            s = arr.join('');                // Convert Array to string
            return s;                        // Return shuffled string
        },

        /**
         * Remove special character from string
         */
        removeAccents(strAccents){
            strAccents = strAccents.split('');
            let strAccentsOut = new Array();
            let strAccentsLen = strAccents.length;
            let accents = 'ÀÁÂÃÄÅàáâãäåÒÓÔÕÕÖØòóôõöøÈÉÊËèéêëðÇçÐÌÍÎÏìíîïÙÚÛÜùúûüÑñŠšŸÿýŽž';
            let accentsOut = [
                'A','A','A','A','A','A','a','a','a','a','a','a','O','O','O','O','O','O','O','o',
                'o','o','o','o','o','E','E','E','E','e','e','e','e','e','C','c','D','I','I','I','I',
                'i','i','i','i','U','U','U','U','u','u','u','u','N','n','S','s','Y','y','y','Z','z'
            ];
            for (let y = 0; y < strAccentsLen; y++) {
                if (accents.indexOf(strAccents[y]) != -1) {
                    strAccentsOut[y] = accentsOut[accents.indexOf(strAccents[y])];
                }
                else
                    strAccentsOut[y] = strAccents[y];
            }
            strAccentsOut = strAccentsOut.join('');
            return strAccentsOut;
        }, 

        async checkInternetConnection() {
            try {
              const response = await fetch('https://www.google.com', { mode: 'no-cors' });
              if (response.ok || response.type === 'opaque') {
                return true
              } else {
                return false
              }
            } catch (error) {
              return false
            }
        },

        // getCurrencyInfo() {
        //     this.$store.dispatch('getConfigInfoClinique', 'currency').then((response) => {
        //         this.currency_info = {
        //             principal_currency: response.principal_currency,
        //             secondary_currency: response.secondary_currency,
        //             rate: response.rate
        //         }
        //     })
        // },

        formatPercentage(value) {
            const number = Number(value)
            if (Number.isNaN(number)) {
                return '0'
            }
            return formatNumberCompact(number.toFixed(2))
        },

        convertDataTypeToLibelle(data_type) {
            let libelle = ''
            switch (data_type) {
                case 'consultation':
                    libelle = 'Consultations';
                    break;
                case 'acte':
                    libelle = 'Actes';
                    break;
                case 'admission':
                    libelle = 'Admissions';
                    break;
                case 'analyse':
                    libelle = 'Analyses';
                    break;
                case 'apport_social':
                    libelle = 'Apport social';
                    break;
                case 'bon_consultation':
                    libelle = 'Bon de consultation';
                    break;
                case 'chambre':
                    libelle = 'Chambres';
                    break;
                case 'consommable':
                    libelle = 'Consommables';
                    break;
                case 'consommable_bon':
                    libelle = 'Consommables de bon de consultation';
                    break;
                case 'depense':
                    libelle = 'Dépenses';
                    break;
                case 'examen':
                    libelle = 'Examens';
                    break;
                case 'medicament':
                    libelle = 'Médicaments';
                    break;
                case 'observation':
                    libelle = 'Observations';
                    break;
                case 'chirurgie':
                    libelle = 'Chirurgies';
                    break;
                case 'bilan_sante':
                    libelle = 'Bilan de santé';
                    break;
                case 'reglement_dette':
                    libelle = 'Règlement de dettes';
                    break;
                case 'autre_prestation':
                    libelle = 'Autres';
                    break;
            }
            return libelle;
        },

        checkIfCanPreview(filename) {
            let can_view = false

            if (filename != '') {
                if (
                    filename.includes('pdf') || filename.includes('png') || 
                    filename.includes('PNG') || filename.includes('jpeg') || filename.includes('JPEG') || 
                    filename.includes('jpg') || filename.includes('JPG') 
                ) {
                    can_view = true
                }
            }
            return can_view
        }
    }
};

// Export a separate token variable for global access
export let token = ""; 

// Function to update the token
export function setToken(newToken) {
    token = newToken;
}
